<form #form novalidate>
  <div id="alterationDetailsContainer" class="container fixed bottom-0 right-0 z-30 hiddenDetails cursor-default"
    [ngClass]="{ 'openDetails': (alterationDetail() || isNewLikeAlteration()) && !closed(), 'w-8!': closed(), 'h-[calc(100%-142px)]': !isNewLikeAlteration(), 'h-[calc(100%-80px)]': isNewLikeAlteration() }">
    @if (!closed()) {
      <section class="topbar h-14 mt-4 flex items-center">
        <div class="flex gap-2 items-center">
          <h1 class="ml-8 text-xl font-semibold">
            {{ literalService.get(`alterations.${formTitle()}`, true) }}
          </h1>
          <div class="flex items-center justify-center cursor-pointer content-image" (click)="editStatus = !editStatus" [tooltip]="literalService.get(alterationStatus, true)" [position]="TooltipPosition.BELOW">
            <img [src]="images.alterations.alteration" [alt]="alterationStatus" class="h-6 w-6" />
          </div>
          @if (editStatus) {
            <app-select [elements]="alterationStatusList" [value]="alterationStatus" [id]="alterationStatus" [translateValue]="true" [autoOpen]="true" (changeEventEmitter)="changeStatus($event)" (onBlur)="changeStatus(null)" />
          }
        </div>
        <div id="actions" class="flex ml-auto mr-8 gap-2.5">
          @if (!isNewLikeAlteration()) {
            <div class="flex items-center justify-center cursor-pointer" (click)="onEdit()" [tooltip]="literalService.get('alterations.tooltips.edit', true)" [position]="TooltipPosition.BELOW">
              <img [src]="images.alterations.edit" alt="edit" class="h-6 w-6" />
            </div>
            @if (userRole === UserRole.SUPERADMIN) {
              <div class="flex items-center justify-center cursor-pointer" (click)="onDelete()" [tooltip]="literalService.get('alterations.tooltips.delete', true)" [position]="TooltipPosition.BELOW">
                <img [src]="images.trash" alt="delete" class="h-5 w-5" />
              </div>
            }
          }
          <div class="flex items-center justify-center cursor-pointer" (click)="onClose()" [tooltip]="literalService.get('close', true)" [position]="TooltipPosition.BELOW">
            <img [src]="images.close" alt="closeDetails" class="h-6 w-6" />
          </div>
        </div>
      </section>
    }
    <section class="flex flex-col pt-8 items-center justify-between overflow-auto h-[calc(100%-72px)]">
      <div class="flex">
        @if (!closed()) {
          <div class="grid grid-rows-7 grid-flow-col gap-4">
            @if (!edit() && !isNewLikeAlteration()) {
              @for (element of alterationForm; track $index) {
                <article class="-mb-3.5 w-72" [ngClass]="{'hidden': element.hidden, 'row-span-2': element.edit.inputType === InputType.LONG_TEXT && element.value.length >= 100}">
                  <app-detail [data]="element" [value]="element.value" />
                </article>
              }
            } @else {
              @for (element of alterationForm; track $index) {
                <article [ngClass]="{'row-span-2': element.edit.inputType === InputType.LONG_TEXT, 'hidden': element.hidden}">
                <app-input [data]="element"
                            [edit]="true"
                            [independent]="false"
                            [translateValue]="element.edit?.translateValue"
                            (setEventEmitter)="changeData($event, element)"
                            (changeEventEmitter)="changeData($event, element)" />
                </article>
              }
            }
          </div>
        }
        @if (closed()) {
          <section class="flex items-center absolute right-2 top-0 bottom-0">
            <img alt="arrowToExpand" [src]="images.arrowLeft" class="h-5 w-5 cursor-pointer expand" (click)="onExpand()" />
          </section>
        }
      </div>
      @if (alterationDetail() && !edit() && !isNewLikeAlteration()) {
        <div class="flex text-right justify-end items-end">
          <div class="text-right mt-5">
            @if (alterationDetail()?.creatorName || alterationDetail()?.createdAt) {
              <p class="changelog primary-purple-light-text font-light text-sm">{{ literalService.get('created', true) }}
                @if (alterationDetail()?.creatorName) {
                  <span class="changelog font-light text-sm"> {{ literalService.get('by') }} {{ alterationDetail()?.creatorName }}</span>
                }
                {{ literalService.get('at') }} {{ utilsService.convertDate(alterationDetail()?.createdAt) | date: 'dd/MM/yyyy HH:mm' }}
              </p>
            }
            @if (alterationDetail()?.modifierName || alterationDetail()?.lastModifiedAt) {
              <p class="changelog primary-purple-light-text font-light text-sm">{{ literalService.get('lastModification', true) }}
                @if (alterationDetail()?.modifierName) {
                  <span class="changelog font-light text-sm"> {{ literalService.get('by') }} {{ alterationDetail()?.modifierName }}</span>
                }
                {{ literalService.get('at') }} {{ utilsService.convertDate(alterationDetail()?.lastModifiedAt) | date: 'dd/MM/yyyy HH:mm' }}
              </p>                                            
            }
          </div>
        </div>
      }
    </section>
  </div>
</form>
